import AuditTrailReportActionTypes from './audit-trail-report.type';

/******************* GET AUDIT TRAIL REPORT START *****************/
export const getAuditTrailReportStart = (getData: any) => ({
	type: AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_START,
	payload: getData,
});

export const getAuditTrailReportSuccess = (successData: any) => ({
	type: AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getAuditTrailReportFailure = (failureData: any) => ({
	type: AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getAuditTrailReportResponseResetStart = () => ({
	type: AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_RESPONSE_RESET,
});

export const getAuditTrailReportResponseChanged = () => ({
	type: AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_RESPONSE_CHANGED,
});
/******************* GET AUDIT TRAIL REPORT END *******************/

/** ***************** AUDIT TRAIL REPORT REPORT EXCEL START *********************** */
export const getAuditTrailReportExcelStart = (user: any) => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_START,
	payload: user,
});

export const getAuditTrailReportExcelSuccess = (user: any) => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_SUCCESS,
	payload: user,
});

export const getAuditTrailReportExcelFailure = (error: any) => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_FAILURE,
	payload: error,
});

export const getAuditTrailReportExcelResponseReset = () => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_RESET,
});

export const getAuditTrailReportExcelResponseChanged = () => ({
	type: AuditTrailReportActionTypes.FETCH_POST_TRAIL_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** AUDIT TRAIL REPORT REPORT EXCEL END *********************** */

/** ***************** FETCH POST AUDIT TRAIL REPORT JSON START *********************** */
export const getAuditTrailReportJsonStart = (user: any) => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_START,
	payload: user,
});

export const getAuditTrailReportJsonSuccess = (user: any) => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_SUCCESS,
	payload: user,
});

export const getAuditTrailReportJsonFailure = (error: any) => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_FAILURE,
	payload: error,
});

export const getAuditTrailReportJsonResponseReset = () => ({
	type: AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_RESET,
});

export const getAuditTrailReportJsonResponseChanged = () => ({
	type: AuditTrailReportActionTypes.FETCH_POST_TRAIL_REPORT_LIST_JSON_RESPONSE_CHANGED,
});
/** ***************** FETCH POST AUDIT TRAIL REPORT JSON END *********************** */
